import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resignationAddonName',
})
export class ResignationAddonNamePipe implements PipeTransform {
  transform(addonName: string): string {
    return addonName.replace(/ -.*/, '') ?? addonName;
  }
}
